export const memberNodesFormatter = (start: number | string, end: number | string) => (
  <>
    {start + " "}&#8594;{" " + end}
  </>
);
